"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var styles = {
  "sidebar-title": "sidebar-title_2ncQ1-",
  "sidebarTitle": "sidebar-title_2ncQ1-",
  "title": "title_2ZYTX9"
}; 
require('./SidebarTitle.css');
var SidebarTitle = function SidebarTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.sidebarTitle
  }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("h5", {
    className: styles.title
  }, children));
};
var _default = exports.default = SidebarTitle;
//# sourceMappingURL=SidebarTitle.js.map